exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_object-gops.js
// module id = 70
// module chunks = 0 1